import React from "react";
import SecondaryButton from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ConfirmRequest = (props) => {
  const { message, onConfirm, onClose } = props;

  const { t } = useTranslation();

  return (
    <Container data-testid="confirm-request">
      <span dangerouslySetInnerHTML={{ __html: message }} />
      <ActionButtonsContainer>
        <SecondaryButton
          data-testid="cancel-button"
          className="mr-2"
          onClick={onClose}
        >
          {t("appText.confirmRequest.cancel")}
        </SecondaryButton>
        <PrimaryButton data-testid="confirm-button" onClick={onConfirm}>
          {t("appText.confirmRequest.confirm")}
        </PrimaryButton>
      </ActionButtonsContainer>
    </Container>
  );
};

ConfirmRequest.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withTheme(ConfirmRequest);
